import type { User } from "@/models/auth/User";

export const isProfileComplete = (user: User | null | undefined): boolean => {
  if (!user) return false;
  return Boolean(
    user.display_name?.trim() &&
      user.state?.id &&
      user.city?.id &&
      user.gender &&
      user.birthdate,
  );
};
